export class Keyboard {

  static readonly KEY_LEFT: number = 37;
  static readonly KEY_RIGHT: number = 39;
  static readonly KEY_UP: number = 38;
  static readonly KEY_DOWN: number = 40;
  static readonly KEY_SPACE: number = 32;
  static readonly KEY_ESC: number = 27;
  static readonly validKeyCodes: number[] = [Keyboard.KEY_LEFT, Keyboard.KEY_RIGHT, Keyboard.KEY_DOWN, Keyboard.KEY_UP, Keyboard.KEY_SPACE, Keyboard.KEY_ESC];
  static readonly repeatKeysMilliseconds: {[keyCode: number]: number} = {
    [Keyboard.KEY_LEFT]: 150,
    [Keyboard.KEY_RIGHT]: 150,
    [Keyboard.KEY_DOWN]: 100,
    [Keyboard.KEY_UP]: 300
  };
  // sticky keys are considered pressed until the key code is consumed.
  static readonly stickyKeyCodes: number[] = [Keyboard.KEY_ESC, Keyboard.KEY_UP];

  private currentKeysDown: Set<number>;
  private repeatTimers: {[keyCode: number]: any};

  constructor() {
    this.currentKeysDown = new Set();
    this.repeatTimers = {};
  }

  install(): Keyboard {
    window.addEventListener("keydown", (ev: KeyboardEvent) => {
      if (!ev.repeat) {
        const keyCode = ev.keyCode;
        if (Keyboard.validKeyCodes.indexOf(keyCode) !== -1) {
          ev.preventDefault();
          this.startRepeat(keyCode);
          this.currentKeysDown.add(keyCode);
          // console.log(`keyDown ${keyCode}. keys down: %o`, this.currentKeysDown);
        } else {
          // console.log(`keyDown ${keyCode}. unrecognised. keys down: %o`, this.currentKeysDown);
        }
      }
    });
    window.addEventListener("keyup", (ev: KeyboardEvent) => {
      const keyCode = ev.keyCode;
      if (Keyboard.validKeyCodes.indexOf(keyCode) !== -1) {
        this.stopRepeat(keyCode);
        if (Keyboard.stickyKeyCodes.indexOf(keyCode) !== -1) {
          // console.log(`keyUp ${keyCode}. is sticky key. keys down: %o`, this.currentKeysDown);
        } else {
          this.currentKeysDown.delete(keyCode);
          // console.log(`keyUp ${keyCode}. keys down: %o`, this.currentKeysDown);
        }
        
      } else {
        // console.log(`keyUp ${keyCode}. unrecognised. keys down: %o`, this.currentKeysDown);
      }
    });
    return this;
  }

  consumeKeyPress(...keyCodes: number[]): number | null {
    let foundKeyCode: number | null = null;
    this.currentKeysDown.forEach(keyCode => {
      if (!foundKeyCode && keyCodes.indexOf(keyCode) !== -1) {
        this.currentKeysDown.delete(keyCode);
        // console.log(`key consumed ${keyCode}. keys down: %o`, this.currentKeysDown);
        foundKeyCode = keyCode;
      }
    });
    return foundKeyCode;
  }

  unconsumeKeyPress(keyCode: number): void {
    this.currentKeysDown.add(keyCode);
  }

  private startRepeat(keyCode: number) {
    this.stopRepeat(keyCode);
    let ms;
    if ((ms = Keyboard.repeatKeysMilliseconds[keyCode])) {
      this.repeatTimers[keyCode] = setInterval(() => this.doRepeat(keyCode), ms);
    }
  }

  private stopRepeat(keyCode: number) {
    clearInterval(this.repeatTimers[keyCode]);
    delete this.repeatTimers[keyCode];
  }

  private doRepeat(keyCode: number) {
    this.currentKeysDown.add(keyCode);
    // console.log(`key repeat ${keyCode}. keys down %o`, this.currentKeysDown);
  }

}